export const CHAT_WINDOW_COLOR = '#f9fafc'
export const COLOR_SUCCESS = '#57cb5b'
export const COLOR_DANGER = '#ef5350'
